import { jsx as l } from "react/jsx-runtime";
import { useMemo as v, useState as x, useEffect as A } from "react";
function y(e) {
  return Array.isArray(e) ? e : [e];
}
function B(e, t) {
  return v(
    () => ({
      display: "grid",
      alignItems: "start",
      gridColumnGap: t,
      gridTemplateColumns: `repeat(${e}, minmax(0, 1fr))`
    }),
    [e, t]
  );
}
function E(e, t, n) {
  const [r, o] = x({ columns: 0, gap: 1 });
  return A(() => {
    if (!e) {
      o({ columns: t[0], gap: n[0] });
      return;
    }
    const a = e.map(
      (s) => window.matchMedia(`(min-width: ${s}px)`)
    ), u = () => {
      let s = 0;
      a.forEach((c) => {
        c.matches && s++;
      });
      const i = Math.min(a.length - 1, Math.max(0, s));
      o({ columns: t[i], gap: n[i] });
    };
    u();
    for (const s of a)
      s.addEventListener("change", u);
    return () => {
      for (const s of a)
        s.removeEventListener("change", u);
    };
  }, [e, t, n]), r;
}
function I({
  items: e = [],
  render: t,
  config: n,
  as: r = "div",
  ...o
}) {
  const [a, u] = x(/* @__PURE__ */ new Map()), { columns: s, gap: i } = E(
    n.media,
    y(n.columns),
    y(n.gap)
  ), c = B(s, i);
  if (!s) return null;
  const C = n.useBalancedLayout ? H(e, s, (f) => a.get(f) ?? 0) : G(S(e, s), s);
  return /* @__PURE__ */ l(r, { ...o, style: c, children: C.map((f, M) => /* @__PURE__ */ l(L, { gap: i, children: f.map((h, m) => /* @__PURE__ */ l(
    "div",
    {
      ref: (d) => {
        if (d && n.useBalancedLayout) {
          const g = d.getBoundingClientRect().height;
          a.get(h) !== g && u((w) => {
            const p = new Map(w);
            return p.set(h, g), p;
          });
        }
      },
      children: t(h, m)
    },
    m
  )) }, M)) });
}
function L({
  children: e,
  gap: t
}) {
  return /* @__PURE__ */ l(
    "div",
    {
      style: {
        display: "grid",
        rowGap: t,
        gridTemplateColumns: "minmax(0, 1fr)"
      },
      children: e
    }
  );
}
function S(e = [], t = 3) {
  const n = [];
  for (let r = 0; r < e.length; r += t) {
    const o = e.slice(r, r + t);
    n.push(o);
  }
  return n;
}
function G(e = [], t = 3) {
  const n = Array.from({ length: t }, () => []);
  for (let r = 0; r < t; r++)
    for (let o = 0; o < e.length; o += 1)
      e[o][r] && n[r].push(e[o][r]);
  return n;
}
function H(e, t, n) {
  const r = Array.from({ length: t }, () => []), o = new Array(t).fill(0);
  for (const a of e) {
    let u = 0, s = o[0];
    for (let i = 1; i < t; i++)
      o[i] < s && (s = o[i], u = i);
    r[u].push(a), o[u] += n(a);
  }
  return r;
}
export {
  I as Masonry,
  L as MasonryRow,
  H as createBalancedColumns,
  S as createChunks,
  G as createDataColumns
};
